export const ICONS = {
  ARROW_LEFT: '#icon-arrow-left',
  ARROW_LIGHT_LEFT: '#icon-arrow-light-left',
  ARROW_UP: '#icon-arrow-up',
  ARROW_DOWN: '#icon-arrow-down',
  ARROW_RIGHT: '#icon-arrow-right',
  ARROW_LIGHT_RIGHT: '#icon-arrow-light-right',
  ARROW_BG_START: '#arrow_bg-start',
  ARROW_BG_END: '#arrow_bg-end',
  CLOSE: '#icon-close',
  CLOSE_BOLD: '#close-cross-bold',
  FACEBOOK: '#icon-facebook',
  FACEBOOK_INVERSE: '#icon-facebook-inverse',
  INSTAGRAM: '#icon-instagram',
  LOGO: '#logo',
  LOGO_V2: '#logo-v2',
  LOGO_TEXT_HORIZONTAL: '#logo-with-text-horizontal',
  LOGO_TEXT_VERTICAL: '#logo-with-text-vertical',
  TWITTER: '#icon-twitter',
  YOUTUBE: '#icon-youtube',
  CALENDAR: '#icon-calendar',
  CALENDAR_PLUS: '#icon-calendar-plus',
  MAP_MARKER: '#icon-map-marker',
  MENU: '#icon-menu',
  SEARCH: '#icon-search',
  GLOBE: '#icon-globe',
  PRO: '#icon-pro',
  USER_MALE: '#icon-user-male',
  USER_FEMALE: '#icon-user-female',
  USER_MALE_Q: '#icon-user-male-q',
  USER_FEMALE_Q: '#icon-user-female-q',
  STAR: '#icon-star',
  SLIDERS: '#icon-sliders',
  CADDIE: '#icon-caddie',
  NIBT_BLOCK: '#icon-nibt-block',
  NIBT_BUBBLE: '#icon-nibt-bubble',
  NIBT_FACE: '#icon-nibt-face',
  LOGIN_USER: '#icon-login-user',
  LOGIN_PASSWORD: '#icon-login-password',
  CHECKMARK: '#icon-checkmark',
  PIN_FLAG: '#pin-flag',
  LOCATION: '#location-marker',
  CIRCLE_CAR: '#icon-car',
  CIRCLE_FLAG: "#icon-flag",
  CIRCLE_GOLFBAG: '#icon-golfbag',
  CIRCLE_PLAYER: '#icon-player',
  CIRCLE_TROPHY: '#icon-trophy',
  VOUCHER: '#voucher-icon',
  BUTTON_ARROW_RIGHT: "#button-arrow-right",
  PLAYER: '#icon-player-small',
  GOLFBAG: "#icon-golfbag-small",
  FLAG: "#icon-flag-small",
  PLAY: "#icon-play",
  INFO: "#icon-info",
  MAP: "#icon-map",
  SAVENOWBG: "#icon-savenowbg",
  SMALL_GOLFER: "#icon-smallgolfer",
};



// WEBPACK FOOTER //
// ./src/modules/common/components/icon/Icons.js